import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import lang from '../lang';
const { URL_PREFIX } = window;

const Menu = ({ isCollapsed, toggleCollapse, onMenuClicked, changeState, meShown, notifShown }) => (
    <div className={isCollapsed ? 'menu-fix collapsed' : 'menu-fix'} data-background-color="white" data-active-color="danger">
        <div className="toggle-space">
            <a
                href="/"
                className="btn-toggle"
                onClick={(e) => {
                    e.preventDefault();
                    toggleCollapse(!isCollapsed);
                }}
            >
                <i className="fa fa-bars" style={{ fontSize: 24, float: isCollapsed ? 'left' : 'none' }} />
                <p>Menu</p>
            </a>
        </div>
        <div className="clearfix" />
        <div className="toggle-space menu">
            <a
                href="/"
                className="btn-toggle"
                onClick={(e) => {
                    e.preventDefault();
                    onMenuClicked('app');
                }}
            >
                <i className="fa fa-box-open fa-2x" style={{ float: isCollapsed ? 'left' : 'none' }} />
                <p>{lang.menu.app}</p>
            </a>
            <div className="clearfix" />
            <a
                href="/"
                className="btn-toggle"
                onClick={(e) => {
                    e.preventDefault();
                    onMenuClicked('users');
                }}
            >
                <i className="fa fa-users-cog fa-2x" style={{ float: isCollapsed ? 'left' : 'none' }} />
                <p>{lang.menu.userManagement}</p>
            </a>
            <div className="clearfix" />
            <a
                href="/"
                className="btn-toggle"
                onClick={(e) => {
                    e.preventDefault();
                    changeState('meShown', !meShown);
                }}
            >
                <i className="fa fa-user-circle fa-2x" style={{ float: isCollapsed ? 'left' : 'none' }} />
                <p>{lang.menu.myAccount}</p>
            </a>
            <div className="clearfix" />
            <a
                href="/"
                className="btn-toggle"
                onClick={(e) => {
                    e.preventDefault();
                    changeState('notifShown', !notifShown);
                }}
            >
                <i className="fa fa-bell fa-2x" style={{ float: isCollapsed ? 'left' : 'none' }} />
                <p>{lang.menu.notifications}</p>
            </a>
            <div className="clearfix" />
            <Link
                to={`${URL_PREFIX}/logout`}
                className="btn-toggle"
            >
                <button className="btn btn-default">
                    <i style={{ color: 'red', fontStyle: 'normal', fontSize: 12 }}>{lang.menu.logout}</i>
                </button>
            </Link>
        </div>
    </div>
);

Menu.propTypes = {
    isCollapsed: propTypes.bool.isRequired,
    toggleCollapse: propTypes.func.isRequired,
    onMenuClicked: propTypes.func.isRequired,
    changeState: propTypes.func.isRequired,
    meShown: propTypes.bool.isRequired,
    notifShown: propTypes.bool.isRequired,
};

export default Menu;
